import {combineReducers} from 'redux';

import create from './org-member-create/reducer';
import index from './org-members-index/reducer';
import instance from './org-member-instance/reducer';
import invite from './org-member-invite/reducer';

export default combineReducers({create, index, invite, instance});
